import { Chip, ChipProps } from '@mui/material'

export function NewFeatureChip(props: ChipProps) {
  return (
    <Chip
      label="Novo"
      size="small"
      {...props}
      sx={{
        height: 20,
        fontSize: 12,
        fontWeight: 700,
        bgcolor: 'secondary.main',
        color: 'primary.dark',
        ...props.sx,
      }}
    />
  )
}
